// extracted by mini-css-extract-plugin
export default {"title":"voteId_title__EDuh8"};